import { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning';
}

export default function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-[0.7rem] font-medium uppercase tracking-[0.05em] transition-colors duration-150',
        {
          'border-transparent bg-accent2/15 text-accent2': variant === 'default',
          'border-glass bg-glass-3 text-glass-text': variant === 'secondary',
          'border-transparent bg-[rgb(var(--danger)/0.15)] text-[rgb(var(--danger))]':
            variant === 'destructive',
          'border-glass text-glass-text bg-transparent': variant === 'outline',
          'border-transparent bg-[rgb(var(--pos)/0.15)] text-[rgb(var(--pos))]':
            variant === 'success',
          'border-transparent bg-[rgb(var(--warn)/0.15)] text-[rgb(var(--warn))]':
            variant === 'warning',
        },
        className
      )}
      {...props}
    />
  );
}
